import type { AppRouteModule } from "/@/router/types";

import { LAYOUT } from "/@/router/constant";

const template: AppRouteModule = {
  path: "/template",
  name: "Template",
  component: LAYOUT,
  redirect: "/template/index",
  meta: {
    hideChildrenInMenu: false,
    icon: "ant-design:home-outlined",
    title: "模板",
    orderNo: 1,
  },
  children: [
    {
      path: "index",
      name: "TemplateIndex",
      component: () => import("/@/views/template/index.vue"),
      meta: {
        title: "模板列表",
        hideMenu: false,
      },
    },
    {
      path: "add",
      name: "TemplateAdd",
      component: () => import("/@/views/template/addAndEdit.vue"),
      meta: {
        title: "模板新增",
      },
    },
    {
      path: "tag",
      name: "TagList",
      component: () => import("/@/views/template/tag.vue"),
      meta: {
        title: "标签管理",
        hideMenu: false,
      },
    },

    {
      path: "edit/:tpId",
      name: "TemplateEdit",
      component: () => import("/@/views/template/addAndEdit.vue"),
      meta: {
        title: "模板修改",
        hideMenu: true,
      },
    },
    // {
    //   path: "preEdit",
    //   name: "PreArticleEdit",
    //   component: () => import("/@/views/template/preEdit.vue"),
    //   meta: {
    //     title: "预发布软文修改",
    //     hideMenu: true,
    //   },
    // },
  ],
};

export default template;
